// extracted by mini-css-extract-plugin
module.exports = {"container":"results__container___YER9H","empty":"results__empty___kbUlY"};